import { render, staticRenderFns } from "./tags_list.vue?vue&type=template&id=c271ec6c&scoped=true"
import script from "./tags_list.vue?vue&type=script&lang=js"
export * from "./tags_list.vue?vue&type=script&lang=js"
import style0 from "./tags_list.vue?vue&type=style&index=0&id=c271ec6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c271ec6c",
  null
  
)

export default component.exports